import { render, staticRenderFns } from "./SelectTipoConcedente.vue?vue&type=template&id=264e1262"
import script from "./SelectTipoConcedente.vue?vue&type=script&lang=js"
export * from "./SelectTipoConcedente.vue?vue&type=script&lang=js"
import style0 from "./SelectTipoConcedente.vue?vue&type=style&index=0&id=264e1262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports